var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.476868,
    y: 0.87207,
    width: 35.9803,
    height: 36.0048,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_336",
    transform: "matrix(0.0111111 0 0 0.0111036 0 0.000339198)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_336",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADV0lEQVR4nO2bv2sUURDH1x+IIIqiEPXe3N6bRMUUsdB7c4pwlVZaqNhoZ2lpY6F/gIVgYyMRIlhaaWcVGxttbNLYWFhYiIKQiIpmZe9iYcjt7u3t2zer3w8MBC6b3f3c7Oy82U0UAQAAAAAAAAAAAAAAAAAAgAo5Fse7nbEvhThB8GgHxr4+fuDwvolkz01N7RDDzyGaN5TsyC6e2ntkZyWZPTs7u00MP4Fs/luy4Wf9ON5exummUR9cjqItztgFyOY/5eJRP+pvLeMycsSP8zZ2xHchm+9HUbQ5KymF+OFIi0UvB2nzzf9VtjP2TtEymym6aIEXY68L8a/QJy71xaqQvTFO45ArumjL0jP2qhj745/PYuKfzthrWS5Ot9t71rfCxUQPZS/1zKFW1g66bXvOEX8NLUN8hbHfpWUvZTqI4/1C/Gb9tsVFD2v2u56ZnsnaUc90+mLsl+BSqPJYdtQ5m3XuEscdR/btRtuPJXr4rfIHadm5zG+V+ISQ/ahATlJFOMOfuwenT+ZIPipk34/6G+OLrmjH0pSoKLFKiV6LZSF7puylJA2IKkvlJKLTPvJb2ZuDaI8CN/8e2fNFb/4TiZ6k3RHN4aGdnVh02QZelIavBVpVosdekorC8DlyqFT0OEMWUZfJfodoPkR7P2ipPrwnhxfRTZr8uZrKnTfRDZj8rdZ5A/cqei1eaZv8uQAtaR2iK2/+JdAETr9oPZO/5UkmcI0QHXry5wIPwuoVHeqETfjRbu2ipebJn5KSFUx0UsvkT9Hjt2CixXebVWAC1zV8pa62Mqho8bRw0LhQ0iA6qXIprHXpr0a0pGHsvdx3/ojnR2cyz+cNs9J9hDg3XaJpkNkLqdDMjGzxRUf8QohXhosQu9g1fCFrm9AvZqoTLcPL/2nZV2C1PnBQKVoqfKlbyyM0taKl4OSvKf8Ool10Mlgd5iyfRy7jjV0KffyNES3DWBGyt4qUEjczs0sM39b2smVTRCdpOOJPYuyDtMNI5xdp/U0j/TntRNLPBr+j4FgbLVoaHBBNEJ2EzkJkNIUXh9JB4aWiRhNEJ6EzDhlN4SWhdFB4gajRpCuwYCGITkJnITKawotD6aDwUlGjSaFoAAAAAAAAAAAAAAAAAAAAEOXzG5afWHD2oqIpAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailDark);
export default __webpack_public_path__ + "static/media/mail-dark.bbf7411dae156d3a62929fc69c6ff2e3.svg";
export { ForwardRef as ReactComponent };